export const ICON_NAME = {
  downloads: 'eva:download-fill',
  gear: 'eva:settings-2-fill',
  eye: 'clarity:eye-solid',
  tags: 'mdi:tag-multiple',
  alerts: 'eva:bell-fill',
  reports: 'iconoir:reports-solid',
  import: 'uil:import',
  tag: 'mdi:tag-edit',
  export: 'uil:export',
  requirement: 'iconoir:page-star',
  input: 'iconoir:input-field',
  legal: 'icomoon-free:section',
  legalRequirement: 'iconoir:page-edit',
  blog: 'ic_blog',
  delta: 'material-symbols:difference',
  history: 'eva:clock-fill',
  integration: 'oui:integration-general',
  radar: 'material-symbols-light:radar',
  translation: 'dashicons:translation',
  view: 'eva:eye-outline',
  edit: 'eva:edit-fill',
  add: 'eva:plus-circle-outline',
  access: 'eva:person-outline',
  publish: 'material-symbols:published-with-changes',
  close: 'material-symbols:close',
  admin: 'mdi:administrator-outline',
  delete: 'eva:trash-2-outline',
  approve: 'mdi:check-circle-outline',
  decline: 'mdi:close-circle-outline',
  attribute: 'material-symbols:edit-attributes-outline',
  expand: 'eva:arrow-ios-downward-fill',
  light: 'reicon:layer',
  full: 'reicon:layer-filled',
  regulationAccess: 'carbon:group-security',
  bundling: 'uit:object-group',
  organization: 'clarity:employee-group-line',
  organizationGroup: 'gravity-ui:hierarchy',
  attachment: 'clarity:attachment-line',
  home: 'line-md:home',
  nonPublic: 'mdi:web-cancel',
};
